import { FormikProps } from "formik";
import { ICCheckbox } from "../../core-component/form";
import {
  ICFormikDropDown,
  ICFormikTextIArea,
  ICFormikTextInput,
} from "../../core-component/formik";
import UseTranslationHook from "../../hooks/UseTranslationHook";
import {
  getVisibilityTypeOptions,
  PACKAGE_DESCRIPTION_MAX_LENGTH,
} from "../../utils/PurchaseConstants";
import { IPackageEditorForm } from "./PackageEditorController";

interface IPackageDetailsTabProps {
  formikProps: FormikProps<IPackageEditorForm>;
  isFreeTrial: boolean;
  readOnly: boolean;
}

const PackageDetailsTab: React.FC<IPackageDetailsTabProps> = ({
  formikProps,
  isFreeTrial,
  readOnly,
}) => {
  const { t } = UseTranslationHook();
  const { values, setFieldValue } = formikProps;

  return (
    <div className="space-y-4">
      <ICFormikTextInput
        {...formikProps}
        fieldName="name"
        placeholder={t("name")}
        disabled={readOnly}
        required
      />
      <ICFormikTextIArea
        {...formikProps}
        name="description"
        label={t("description")}
        maxLength={PACKAGE_DESCRIPTION_MAX_LENGTH}
        disabled={readOnly}
      />
      <ICFormikDropDown
        {...formikProps}
        name="visibility_type"
        placeholder={t("type")}
        options={getVisibilityTypeOptions(t, isFreeTrial)}
        disabled={readOnly || isFreeTrial}
        required
      />
      <div className="space-y-2">
        <div className="text-sm text-muted">{t("platforms")}</div>
        <ICCheckbox
          label={t("platform_pwa_mobile_always")}
          checked
          disabled
          onChange={() => {}}
        />
        <ICCheckbox
          label={t("platform_desktop")}
          checked={values.has_desktop}
          disabled={readOnly || isFreeTrial}
          onChange={(checked) => setFieldValue("has_desktop", checked)}
        />
      </div>
      <div>
        <ICFormikTextInput
          {...formikProps}
          fieldName="validity"
          placeholder={t("validity_days")}
          type="number"
          disabled={readOnly || isFreeTrial}
          required
        />
        {isFreeTrial && (
          <div className="text-xs text-muted mt-1">{t("free_trial_validity_hint")}</div>
        )}
      </div>
    </div>
  );
};

export default PackageDetailsTab;
